import request from "@/utils/request";
/**
 * 获取登录
 */
export const login = (params) => {
  return request({
    headers: {
      "Content-Type": "application/json",
    },
    url: "oauth/token",
    method: "post",
    params,
  });
};
// 账号角色
export const getAccount = (params) => {
  return request({
    url: "auth/oauth/userinfo",
    method: "get",
    params,
  });
};
